import React from 'react';
import { Stack, Typography } from '@mui/material';

function Empty({
  iconComponent: Icon,
  description = null,
  actionButton,
  children, ...props
}) {
  function renderDescription() {
    if (typeof description === 'string') {
      return <Typography textAlign="center">{description}</Typography>;
    }
    return description;
  }
  return (
    <Stack alignItems="center" gap={3} pt={10} pb={15} px={4} width="100%" {...props}>
      {Icon && <Icon sx={{ fontSize: 100, color: 'grey.400' }} />}
      {renderDescription()}
      {actionButton && React.cloneElement(actionButton, {
        variant: 'outlined',
        size: 'large',
        sx: {
          width: {
            xs: '100%',
            md: 'initial',
          },
        },
      })}
      {children}
    </Stack>
  );
}
export default Empty;
